import React__default from 'react';
import KGrid from '../../Dataview/KGrid/index.js';
import { classes } from '../../Dataview/KGrid/index.styled.js';
import { MAX_THUMBNAIL_TEMPLATE_TO_LOAD } from '../constants.js';
import { DATAVIEW_CSS_GRID_TEMPLATE_COLUMNS } from '../DataView/utils.js';
import DummyCard from '../DummyCard/index.js';
import ThumbnailTemplateActions from '../ThumbnailTemplateActions/index.js';

var DataViewLoading = function DataViewLoading(_a) {
    var _b;
    var _c = _a.testId, testId = _c === void 0 ? "KFThumbnailGeneratorDataViewLoading" : _c;
    return (React__default.createElement(KGrid, { testId: testId, sx: (_b = {
                width: "100%"
            },
            _b["& .".concat(classes.dataview)] = {
                gridTemplateColumns: DATAVIEW_CSS_GRID_TEMPLATE_COLUMNS
            },
            _b), className: "KFThumbnailGeneratorDataViewLoading" }, Array.from(Array(MAX_THUMBNAIL_TEMPLATE_TO_LOAD), function (_, i) { return (React__default.createElement("li", { key: i },
        React__default.createElement(DummyCard, { height: 100, width: 100, loading: true, actionsComponent: React__default.createElement(ThumbnailTemplateActions, { onDownload: function () { }, onInsert: function () { }, onDelete: function () { }, onUpdate: function () { }, onDuplicate: function () { }, loading: true }) }))); })));
};

export { DataViewLoading };
//# sourceMappingURL=index.js.map
